/* eslint-disable prettier/prettier */
<template>
	<div class="create-new-user mh-700">
		<v-row>
			<v-col cols="12">
				<ViewHeader
					src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fpeppers-h800.jpg?alt=media&token=ec0f82d1-e1be-456e-968a-e8871aa7a3ac"
					title="New User Account"
				/>
			</v-col>
		</v-row>
		<v-row row wrap>
			<v-col cols="12">
				<div class="pa-2">
					<v-alert
						color="success"
						type="success"
						:value="showSuccessAlert"
						>Account created, signing you in</v-alert
					>
					<v-alert
						class="pa-2"
						color="error"
						type="error"
						:value="showFailAlert"
					>
						{{ errorMessage }}
					</v-alert>
				</div>
			</v-col>
		</v-row>

		<v-form
			ref="form"
			v-model="valid"
			v-if="showForm"
			class="form new-user-form padded"
		>
			<v-container>
				<v-row>
					<v-col cols="6">
						<v-text-field
							v-model="firstName"
							:rules="[rules.required, rules.nameLength]"
							:counter="50"
							label="First name"
							required
						></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="lastName"
							:rules="[rules.required, rules.nameLength]"
							:counter="50"
							label="Last name"
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-select
							v-model="honorific"
							:items="honorifics"
							:rules="[rules.required]"
							filled
							label="Honorific"
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-select
							v-model="gender"
							:items="genders"
							:rules="[rules.required]"
							filled
							label="Gender"
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-select
							v-model="dietaryRestriction"
							:items="dietaryRestrictions"
							:rules="[rules.required]"
							filled
							label="Dietary Restrictions"
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-if="dietaryRestriction == 'Other'"
							v-model="otherDietary"
							:counter="150"
							:rules="[rules.longlength, rules.required]"
							label="Dietary Restriction"
							:required="dietaryRestriction == 'Other'"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="institution"
							:counter="150"
							:rules="[rules.longlength, rules.required]"
							label="Institution*"
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="streetAddress"
							:counter="150"
							:rules="[rules.required, rules.longlength]"
							label="Street Address"
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="city"
							:counter="150"
							:rules="[rules.required, rules.longlength]"
							label="City"
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="stateProvince"
							:counter="150"
							:rules="[rules.longlength]"
							label="State/Province"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-autocomplete
							v-model="country"
							:items="countries"
							:filter="countryFilter"
							item-text="country"
							item-value="country"
							label="Country"
							:rules="[rules.required]"
							required
						></v-autocomplete>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-select
							v-model="position"
							:items="positions"
							filled
							:rules="[rules.required]"
							label="Position"
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="email"
							:rules="[rules.required, rules.email]"
							label="E-mail"
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="password"
							:append-icon="
								showPassword ? 'fa-eye-slash' : 'fa-eye'
							"
							:type="showPassword ? 'text' : 'password'"
							name="password-input"
							@click:append="showPassword = !showPassword"
							:rules="[
								rules.required,
								rules.passwordMinLength,
								rules.passwordUpperCase,
								rules.passwordLowerCase,
								rules.passwordNumeric
							]"
							label="Password (Shortest length is 10 characters, with a minimum of 1 upper, 1 lower and 1 number)"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="passwordConf"
							label="Confirm Password"
							:rules="[
								rules.required,
								rules.confirmPasswordMatchesPassword
							]"
							:append-icon="
								showConfirmPass ? 'fa-eye-slash' : 'fa-eye'
							"
							:type="showConfirmPass ? 'text' : 'password'"
							name="confirm-password-input"
							@click:append="showConfirmPass = !showConfirmPass"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="2">
						<v-btn @click.stop="submit">Submit</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-form>

		<!-- Policy Dialog -->
		<v-dialog v-model="dialog" persistent max-width="600px">
			<v-card class="mx-auto" max-width="700" outlined>
				<v-card-title>
					<span class="headline">User Agreement</span>
				</v-card-title>
				<v-card-text>
					<p>
						Please review our user agreement below and indicate your
						consent before proceeding.
					</p>

					<article>
						<p class="policy-heading">
							User Profile Data Collection
						</p>

						<p class="policy-paragraph">
							When you register a user account with this site, we
							will collect and store the user profile information
							you provided in the user submission form.
						</p>

						<p class="policy-paragraph">
							We will include the above information in the
							conference program book, and your demographic
							information (position and gender) may be reported to
							granting agencies to meet their requirements for
							funding.
						</p>

						<p class="policy-paragraph">
							We will not provide the email addresses or names of
							attendees to outside organizations, but may provide
							them to the organizers of successive ICBEM
							conferences.
						</p>
					</article>
					<article>
						<p class="policy-paragraph">
							Please review and agree to the following to
							continue:
						</p>
						<v-checkbox
							v-model="userProfileCollectionConsent"
							class="mx-2"
							label="I consent to the information about me as given above to
						be collected and included in the conference program
						book."
						></v-checkbox>
						<v-checkbox
							v-model="userProfileUsageConsent"
							class="mx-2"
							label="I consent to my profile information (with the exception
						of my name, street address and email address) being used
						for the purposes of grant reporting to fulfil the
						requirements of granting agencies."
						></v-checkbox>
					</article>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialog = false"
						>I do not consent</v-btn
					>
					<v-btn
						color="blue darken-1"
						text
						@click="userAgree"
						:disabled="userHasNotConsented"
						>Continue</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import firebase from 'firebase/app';
import ViewHeader from '@/components/ViewHeader.vue';
import Users from '@/services/Users.js';
import Auth from '@/services/Auth.js';
import Logger from '@/services/Logger.js';
import { setTimeout } from 'timers';
import countries from '../plugins/countries.json';
import { mapState } from 'vuex';
export default {
	name: 'CreateNewUser',
	components: {
		ViewHeader
	},
	computed: {
		userHasNotConsented() {
			return (
				!this.userProfileCollectionConsent ||
				!this.userProfileUsageConsent
			);
		},
		stateUser() {
			return this.$store.state.user;
		}
	},
	data: function() {
		return {
			title: 'ICBEM 2020',
			subtitle: 'New User Account',
			dialog: false,
			userProfileCollectionConsent: false,
			userProfileUsageConsent: false,
			valid: false,
			showPassword: false,
			showConfirmPass: false,
			showForm: true,
			showSuccessAlert: false,
			showFailAlert: false,
			errorMessage: '',
			honorifics: ['Dr.', 'Mr.', 'Ms.'],
			genders: [
				'(Male) Cisgender man',
				'(Female) Cisgender woman',
				'Genderqueer',
				'Transgender man',
				'Transgender woman',
				'Nongender',
				'Two-spirit',
				'Questioning or unsure',
				'Prefer not to answer'
			],
			positions: [
				'Academic - Student',
				'Academic - PostDoc',
				'Academic - Faculty',
				'Industry',
				'Government'
			],
			dietaryRestrictions: [
				'None',
				'Vegetarian',
				'Gluten-free',
				'Vegan',
				'Vegetarian',
				'Gluten Free',
				'Nuts',
				'Pescatarian',
				'Other'
			],
			otherDietary: '',
			countries: countries,
			firstName: '',
			lastName: '',
			honorific: '',
			gender: '',
			dietaryRestriction: '',
			institution: '',
			streetAddress: '',
			city: '',
			stateProvince: '',
			country: '',
			position: '',
			email: '',
			password: '',
			passwordConf: '',
			rules: {
				required: value => !!value || 'Required',
				nameLength: value => value.length <= 50 || 'Max 50 characters',
				longlength: value =>
					value.length <= 150 || 'Max 150 characters',
				email: value => /.+@.+/.test(value) || 'Invalid email',
				passwordMinLength: value =>
					value.length >= 10 ||
					'Password must be at least 10 characters',
				passwordUpperCase: v =>
					this.countUpperCaseChars(v) > 0 ||
					'Password must have at least 1 uppercase character',
				passwordLowerCase: v =>
					this.countLowerCaseChars(v) > 0 ||
					'Password must have at least 1 lowercase character',
				passwordNumeric: v =>
					this.countNumericChars(v) > 0 ||
					'Password must have at least 1 number',
				confirmPasswordMatchesPassword: v =>
					v === this.password || 'Passwords must match'
			}
		};
	},
	methods: {
		registerNewUser: async function() {
			await this.createNewFirebaseUser();
		},
		createNewFirebaseUser: function() {
			const parent = this;
			// Create the new user authentication record
			firebase
				.auth()
				.createUserWithEmailAndPassword(this.email, this.password)
				.then(function(data) {
					// New user entry
					var newUser = {
						id: data.user.uid,
						firstName: parent.firstName,
						lastName: parent.lastName,
						honorific: parent.honorific,
						gender: parent.gender,
						dietaryRestriction:
							parent.dietaryRestriction != 'Other'
								? parent.dietaryRestriction
								: parent.otherDietary,
						institution: parent.institution,
						streetAddress: parent.streetAddress,
						city: parent.city,
						stateProvince: parent.stateProvince,
						country: parent.country,
						position: parent.position,
						email: parent.email,
						role: 'user',
						registered: false,
						abstract: false,
						vaccineSubmitted: false
					};
					// eslint-disable-next-line no-unused-vars
					let { id, ...logData } = newUser;
					logData['userId'] = newUser.id; // Avoid key violation from Firebase
					Users.createUser(newUser, function(error) {
						if (error) {
							Logger.logError('Create New User Failure', error);
						} else {
							// Logger.logInfo('User account created');
							// parent.$store.dispatch('fetchUser', { uid: id });
							setTimeout(function() {
								firebase.auth().signOut();
								parent.$store.dispatch('setAdmin', false);
								parent.$store.dispatch(
									'setAuthenticated',
									false
								);
								parent.$router.push('login').catch(() => { });
							}, 2000);
						}
					});
				})
				.catch(error => {
					// Handle Errors here.
					parent.showFailAlert = true;
					if (error.code == 'auth/email-already-in-use') {
						this.errorMessage =
							'That email is already in use. Please use a different email.';
					} else {
						this.errorMessage = error.message;
						Logger.logWarning(
							'Create New User Error - Email already in system',
							error
						);
					}
				});
		},
		cancelNewUserRegistration: function() {
			this.$router.push('/').catch(() => { });
		},
		countUpperCaseChars(str) {
			var count = 0,
				len = str.length;
			for (var i = 0; i < len; i++) {
				if (/[A-Z]/.test(str.charAt(i))) count++;
			}
			return count;
		},
		countLowerCaseChars(str) {
			var count = 0,
				len = str.length;
			for (var i = 0; i < len; i++) {
				if (/[a-z]/.test(str.charAt(i))) count++;
			}
			return count;
		},
		countNumericChars(str) {
			var count = 0,
				len = str.length;
			for (var i = 0; i < len; i++) {
				if (/[0-9]/.test(str.charAt(i))) count++;
			}
			return count;
		},
		countryFilter(item, queryText) {
			const country = item.country.toLowerCase();
			const searchText = queryText.toLowerCase();

			return country.indexOf(searchText) > -1;
		},
		submit() {
			if (this.$refs.form.validate()) {
				this.dialog = true;
			}
		},
		userAgree() {
			this.dialog = false;
			this.registerNewUser();
		}
	}
};
</script>
<style src="@/style.css"></style>
